import ReferencesUserSubordinationArchive from 'features/references/referencesUserSubordinationArchive';
import { useTitle } from '../helpers';

/**
 * @page References user subordination archive page
 */

const ReferencesUserSubordinationArchivePage = () => {
  useTitle('Информация о справке архива подчинённых');

  return (
    <div>
      <h3>Страница информации о справке архива подчинённых</h3>
      <ReferencesUserSubordinationArchive />
    </div>
  );
};

export default ReferencesUserSubordinationArchivePage;
